<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/products/away-from-home-market',
    'fr-CA': '/produits/segment-marche-hors-foyer'
  }
})

useHead({
  title: t('navigation.awayFromHomeMarket.metatitle'),
  meta: [{ name: 'description', content: t('navigation.awayFromHomeMarket.metadescription') }],
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('products-products')">{{ $t('navigation.products.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.awayFromHomeMarket.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.awayFromHomeMarket.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuProducts />
        <div class="contenu right">
          <div class=""
               v-if="$i18n.locale == 'en-CA'">
            <p>Away-From-Home brands include Esteem®, White Swan®, Embassy® and Chalet. The Away-From-Home market consists primarily of the supply of bathroom tissue, facial tissue, paper towels and napkins to commercial users in a variety of industries such as food services, property management, healthcare, manufacturing, education and lodging.</p>
            <p>Kruger Products Management believes that Kruger Products was one of the leaders in the Canadian AFH business in 2022. The Away-from-Home business plays an important role in increasing capacity utilization and spreading the impact of fixed costs. According to Management, the Away-From-Home market tends to be more price sensitive than the Consumer market. It covers a large and diverse base of customers. Kruger Products Inc. also has a small and growing presence in the U.S. market, supplied primarily from Canada. For the year ended December 31, 2022, the Away-From-Home business represented approximately 17% of consolidated revenue.</p>
            <p><a class="btn"
                 href="http://afh.krugerproducts.ca/home.aspx?lang=en-CA&amp;"
                 target="_blank">Away From Home website</a></p>
            <div class="logoMarque">
              <div class="unLogo">
                <span><img src="~/assets/images/chalet.jpg"
                       alt="CHALET"></span>
              </div>
              <div class="unLogo">
                <span><img src="~/assets/images/embassy.jpg"
                       alt="EMBASSY"></span>
              </div>
              <div class="unLogo">
                <span><img src="~/assets/images/whiteswan.jpg"
                       alt="WhiteSwan"></span>
              </div>
            </div>
          </div>
          <div class=""
               v-if="$i18n.locale == 'fr-CA'">
            <p>Les produits de ce segment portent entre autres les marques Esteem<sup>MD</sup>, White Swan<sup>MD</sup>, Embassy<sup>MD</sup> et Chalet<sup>MD</sup>. Le marché hors foyer consiste essentiellement en l'offre de papier hygiénique, de papiers-mouchoirs, d'essuie-tout et de serviettes de table aux utilisateurs commerciaux de différents secteurs comme les services alimentaires, la gestion immobilière, les soins de santé, la fabrication, l'éducation et l'hébergement.</p>
            <p>Selon les estimations de la direction, Produits Kruger inc. est l'un des chefs de file du marché hors foyer en 2022. La Société détenait environ 30&nbsp;% du marché canadien au 31 décembre 2021. Ce segment, qui vise une clientèle vaste et diversifiée, joue un rôle important dans l'augmentation de l'utilisation de capacité et dans la répartition de l'incidence des frais fixes. Selon la direction, il tend à être plus sensible aux prix que le marché des produits de consommation. Aux États-Unis, Produits Kruger inc. est peu présente, mais prend actuellement de l'expansion en s'approvisionnant surtout au Canada. Au terme de l'exercice clos le 31 décembre 2022, le segment du marché hors foyer représentait environ 17&nbsp;% des produits d'exploitation consolidés de la Société.</p>
            <p><a class="btn"
                 href="http://afh.krugerproducts.ca/home.aspx?lang=en-CA&amp;"
                 target="_blank">Segment hors foyer</a></p>
            <div class=" logoMarque">
              <div class=" unLogo">
                <span><img src="~/assets/images/chalet.jpg"
                       alt="CHALET"></span>
              </div>
              <div class=" unLogo">
                <span><img src="~/assets/images/embassy.jpg"
                       alt="EMBASSY"></span>
              </div>
              <div class=" unLogo">
                <span><img src="~/assets/images/whiteswan.jpg"
                       alt="WhiteSwan"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
